import { render } from "./GosuslugiWithTokenView.vue?vue&type=template&id=e9daf20c&scoped=true"
import script from "./GosuslugiWithTokenView.vue?vue&type=script&lang=js"
export * from "./GosuslugiWithTokenView.vue?vue&type=script&lang=js"

import "./GosuslugiWithTokenView.vue?vue&type=style&index=0&id=e9daf20c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9daf20c"]])

export default __exports__